import React from 'react';
import { ButtonSize, OptionSelectionButton, usePopupManager } from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';
import { CreateVersionForm } from './CreateVersionForm';
import { UpdateMarketForm } from '../UpdateMarketForm';
import { SetupArea } from 'nekst-api';
import useFeatureToggleService from 'feature-toggle';
import CopyMarketForm from '../CopyMarketForm';
import DeleteSetupAreaForm from '../DeleteSetupAreaForm';

export function SetupAreaActionsButton(
  props: {
    setupArea: SetupArea,
  }
) {
  const popupFormManager = usePopupFormManager();

  const popupManager = usePopupManager();

  const featureToggleService = useFeatureToggleService();

  const openCopyForm = () => {
    popupFormManager.openForm(<CopyMarketForm setupArea={props.setupArea} />);
  };

  const deleteSetupArea = () =>  {
    popupManager.openPopup((
      <DeleteSetupAreaForm setupArea={props.setupArea} />
    ));
  }

  return (
    <OptionSelectionButton
      text="Actions"
      options={[
        {
          label: 'Update Market',
          onSelected: () => {
            popupFormManager.openForm(<UpdateMarketForm setupArea={props.setupArea} />);
          },
          value: 'update_market'
        },
        ...featureToggleService.isSetupAreasVersioningEnabled() ? [{
          label: 'Create New Version',
          onSelected: () => {
            popupFormManager.openForm(<CreateVersionForm setupArea={props.setupArea} />);
          },
          value: 'create_new_version'
        }] : [],
        ...props.setupArea.market ? [{
          value: 'copy',
          label: 'Copy',
          onSelected: () => openCopyForm()
        }] : [],
        ...!props.setupArea.isDefault ? [{
          value: 'delete',
          label: 'Delete',
          onSelected: () => deleteSetupArea()
        }] : [],
      ]}
      size={ButtonSize.MEDIUM}
    />
  );
}
